import { Link } from "react-router-dom";
import Heart from "../Heart/Heart";
import classes from "./ProductTile.module.css";

const ProductTile = (props) => {
  const cls = [classes.ProductTile];
  if (props.first === true) {
    cls.push(classes.First);
  }

  if (props.discount) {
    cls.push(classes.Discount);
  }

  return (
    <Link
      className={cls.join(" ")}
      to={`/produkte/${props.category?.link}/${props.subcategory?.link}/${
        props.productId
      }-${window.urlifyString(props.title)}`}
    >
      <article>
        <p className={classes.Percentage}>{props.discount}%</p>
        <div className={classes.Image}>
          <img draggable={false} src={props.image} alt={props.title} />
        </div>
        <div className={classes.Price}>
          {props.discountPrice ? (
            <span className={classes.PriceOld}>
              CHF {props.basePrice.toFixed(2)}
            </span>
          ) : null}
          <p>
            CHF{" "}
            {props.discountPrice
              ? props.discountPrice.toFixed(2)
              : props.basePrice.toFixed(2)}
          </p>
        </div>
        <p className={classes.Title}>{props.title}</p>
        <p className={classes.Subtitle}>{props.subtitle}</p>
        <Heart className={classes.Heart} />
      </article>
    </Link>
  );
};

export default ProductTile;
